<template>
	<div class="input-wrapper">
		<div class="label__content">
			<div class="content-header">
				<TypographyKTypographyBody5
					class="label"
					:color="'var(--color_font_black_wite)'"
					font-type="semi-bold"
				>
					{{ label }}
				</TypographyKTypographyBody5>
				<div
					class="content-header__btn"
					@click="changeVisibleField"
				>
					{{ isVisibleInput ? 'Свернуть' : 'Развернуть' }}
				</div>
			</div>

			<!-- Отображение слотов в зависимости от состояния -->
			<div class="slot-container">
				<slot
					name="opened"
					v-if="isVisibleInput"
				/>
				<slot
					name="closed"
					v-else
				/>
			</div>
		</div>

		<UiButton
			:label="btnTitle || (modelValue ? 'Изменить' : '+ Добавить')"
			:size="ButtonSizeType.small"
			:color="ButtonType.primary"
			v-if="isNeedChangeBtn"
			class="btn"
			:is-spinner-loading="isLoading"
			:disabled="isDisabled"
			@click="clickHandler"
		/>
		<slot
			name="additional-content"
			v-if="$slots['additional-content']"
		/>
	</div>
</template>

<script setup lang="ts">
	import { ButtonSizeType, ButtonType } from '~~/shared/interfaces/ui';

	const emits = defineEmits(['clickBtn', 'chooseSuggestion']);
	const modelValue = defineModel('modelValue', { required: true, type: String });

	const props = withDefaults(
		defineProps<{
			readonly?: boolean;
			label?: string;
			isNeedChangeBtn?: boolean;
			isNeedAlwaysVisibleInput?: boolean;
			placeholder?: string;
			btnTitle?: string;
			isLoading?: boolean;
			isDisabled?: boolean;
			suggestions?: any;
			isVisibleSuggestionsDefault?: boolean;
			height?: string;
		}>(),
		{
			height: '50px',
			isNeedAlwaysVisibleInput: true
		}
	);

	const isVisibleInput = ref(props.isNeedAlwaysVisibleInput);

	const changeVisibleField = () => {
		isVisibleInput.value = !isVisibleInput.value;
	};

	const clickHandler = () => {
		emits('clickBtn');
	};
</script>

<style scoped lang="scss">
	.input-wrapper {
		background-color: #eaedf5;
		padding: 10px;
		border-radius: 10px;

		.label__content {
			display: flex;
			flex-direction: column;
			gap: 10px;

			.content-header {
				display: flex;
				justify-content: space-between;
				width: 100%;

				&__btn {
					position: relative;
					font-size: 12px;
					color: #2e4a85;
					font-weight: 500;
					cursor: pointer;
					text-decoration: underline dotted;

					&:hover {
						&::after {
							content: '';
							width: 100%;
							position: absolute;
							left: 0px;
							bottom: -2px;
							border-bottom: 1px solid #2e4a85;
						}
					}
				}
			}
		}

		.btn {
			width: 100%;
			margin-top: 10px;
			min-height: 30px;
		}

		.slot-container {
			width: 100%;
		}
	}
</style>
